import template from "./OrderConfirmTmcStepComponent.html";
import {OrderConfirmComponentController} from "../OrderConfirmController";
import {IOnChangesObject, ITimeoutService} from "angular";
import {OptionsTicket, OptionsWizardTmcOrder} from "../../../../types/OptionsTicket";
import {OrderVettingService} from "../../../../services/OrderVettingService";
import {Premium} from "../../../../types/OrderVettingResponse";
import {CurrentUserService} from "../../../../../../../services/user/CurrentUserService";
import {TmcLeg} from "../../../../services/models/TmcRequests";
import {sum} from "../../../../../../../js/util/UtilFunctions";
import {MarginQuizService} from "../../../../../../../quiz/margin/service/MarginQuizService";
import {AccountStore} from "../../../../../../../account/store/AccountStore";
import {QuoteStore} from "../../../../../../../quote/store/QuoteStore";
import {OrderSide} from "../../../../../../../orders/models/OrderRecord";

export const OrderConfirmTmcStep = "tmcOrderConfirmStep";

export function orderConfirmTmcStep() {
    return {
        template,
        bindings: {
            order: "<",
            portfolio: "<",
            form: "<"
        },
        controllerAs: "ctrl",
        controller: OrderConfirmStepTmcComponentController
    };
}

export class OrderConfirmStepTmcComponentController extends OrderConfirmComponentController {

    public order: OptionsWizardTmcOrder;

    public totalTheo: number;

    /** @ngInject */
    public constructor($timeout: ITimeoutService,
                       currentUserService: CurrentUserService,
                       orderVettingService: OrderVettingService,
                       marginQuizService: MarginQuizService,
                       accountStore: AccountStore,
                       quoteStore: QuoteStore) {
        super($timeout, currentUserService, orderVettingService, marginQuizService, accountStore, quoteStore);
    }

    public async $onChanges(changes: IOnChangesObject): Promise<void> {
        super.$onChanges(changes);
        this.totalTheo = this.calculateTotalTheo();
    }

    private calculateTotalTheo(): number {
        return this.order
                   .legs
                   .map((l) => l.spread.theo! * l.ratio)
                   .reduce(sum, 0);
    }

    protected orderTickets(): Array<OptionsTicket> {
        const legs: Array<TmcLeg> = this.order.legs.map(l => {
            return {
                code: l.code,
                ratio: l.ratio
            };
        });

        const ticket: OptionsTicket = {
            code: this.order.ticket.code,
            quantity: Math.abs(this.order.ticket.quantity),
            limit: this.order.ticket.limit,
            buy: (this.order.side === OrderSide.BUY) || (this.order.side === OrderSide.MULTI_AS_DEFINED),
            description: "",
            legs
        };
        return [ticket];
    }

    protected addPremiumToTrade(premium: Premium): void {
        const leg = this.order.legs.find(l => l.code === premium.code);
        if (leg != null) {
            leg.price = premium.price;
            leg.premium = premium.premium;
        }
    }
}
